import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";
import Accessor from "static/Accessor";

const Table: TablizoSchema[] = [
  {
    label: "FAQ ID",
    name: "FAQ_id",
    filterable: true,
  },
  {
    label: "Count(Like)",
    name: "like",
    valueGetter: (row, field, addOns) => {
      let like = Accessor.Get(row, "like");
      return like !== undefined ? like : "";
    },
  },
  {
    label: "Count(Dislike)",
    name: "dislike",
    valueGetter: (row, field, addOns) => {
      let dislike = Accessor.Get(row, "dislike");
      return dislike !== undefined ? dislike : "";
    },
  },
];

const Info: FormizoSchema[] = [
  {
    label: "Answer ID",
    name: "answerID",
  },
  {
    label: "Intent",
    name: "intent",
  },
  {
    label: "Count(Like)",
    name: "like",
  },
  {
    label: "Count(Dislike)",
    name: "dislike",
  },
];

const Filterables: Filterable[] = [
  {
    field: "FAQ_id",
    label: "FAQ ID",
    type: FieldType.text,
  },
];

const Export = [
  {
    label: "FAQ ID",
    name: "FAQ_id",
  },
  {
    label: "Count(Like)",
    name: "like",
  },
  {
    label: "Count(Dislike)",
    name: "dislike",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
